import React, { useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import logger from "../lib/logger";

// Polls the unread-count endpoint every 30s so the bell badge stays fresh
// without forcing the user to refresh. Mounts wherever you want a bell entry.
export default function NotificationBell({ user, onOpen, className = "" }) {
    const [unread, setUnread] = useState(0);

    const refresh = useCallback(async () => {
        if (!user?.session_id) return;
        try {
            const r = await api.notificationsUnread(user.session_id);
            setUnread(r.unread || 0);
        } catch (e) {
            logger.warn("unread count failed", e);
        }
    }, [user?.session_id]);

    useEffect(() => {
        refresh();
        const id = setInterval(refresh, 30_000);
        return () => clearInterval(id);
    }, [refresh]);

    return (
        <button
            data-testid="notification-bell"
            onClick={onOpen}
            className={`relative tap-target inline-flex items-center gap-1 text-[10px] tracking-[0.32em] uppercase text-burgundy ${className}`}
            aria-label={unread > 0 ? `${unread} unread alerts` : "Alerts"}
        >
            {/* Simple bell glyph */}
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
                <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
            </svg>
            <span>Alerts</span>
            {unread > 0 && (
                <span
                    data-testid="notification-bell-badge"
                    className="absolute -top-1.5 -right-2 min-w-[18px] h-[18px] px-1 rounded-full bg-burgundy text-cream text-[10px] tracking-normal font-bold flex items-center justify-center"
                >
                    {unread > 9 ? "9+" : unread}
                </span>
            )}
        </button>
    );
}
